import Component from 'D:/HBuilderProjects/园博园/uni_modules/atl-map/components/amap/amap.vue'
wx.createComponent(Component)